import { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useForm, SubmitHandler } from "react-hook-form";

import CollapsibleTable from "../../components/collapsible-table";
import Avatar from "@mui/material/Avatar";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import TagColor from "../../components/tag-color";
import UploadButton from "../../components/upload-button";
import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";
import useIventory from "../../hooks/inventory";
import * as XLSX from "xlsx";

const MaterialList = () => {
  const {
    get: getMaterial,
    uploadPhoto,
    create,
    deleteData,
    edit,
  } = useIventory();
  const [material, setMaterial] = useState<IventoryItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [file, setFile] = useState<File>();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<IventoryItem>();

  const loadData = useCallback(() => {
    const fn = async () => {
      const resp = await getMaterial();
      setMaterial(resp);
    };
    fn();
  }, []);

  const onSubmit: SubmitHandler<IventoryItem> = (data) => {
    if (isEdit) {
      if (data.id) edit(data.id, data);
    } else {
      create(data);
    }
    loadData();
    toggleDrawer({});
  };
  const uploadLogo = useCallback(async (userId: string, file: File) => {
    setIsLoading(true);
    await uploadPhoto(userId, file);
    await loadData();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const toggleDrawer = ({ isEdit = false }: { isEdit?: boolean }) => {
    setIsEdit(isEdit);
    reset();
    setOpenDrawer(!openDrawer);
  };
  const openEdit = useCallback((material: IventoryItem) => {
    toggleDrawer({ isEdit: true });
    for (const key in material) {
      setValue(key as keyof IventoryItem, material[key as keyof IventoryItem]);
    }
  }, []);

  const handleFileUpload = async () => {
    if (!file) {
      alert("Selecione um arquivo Excel primeiro!");
      return;
    }

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = e.target?.result;
      if (data) {
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        try {
          for (const item of jsonData as any[]) {
            const newItem: IventoryItem = {
              amountOfItems: item.amount,
              costPerItem: item.cost,
              name: item.name,
              description: item.desc,
              pricePerItem: item.price,
            };
            console.log(newItem);
            create(newItem);
          }

          loadData();
        } catch (error) {
          console.error("Erro:", error);
        }
      }
    };

    reader.readAsBinaryString(file);
  };

  const deleteItem = (id?: string) => {
    if (id) {
      deleteData(id);
      loadData();
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: 2,
        padding: "48px",
        paddingTop: "80px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 2,
          paddingTop: "80px",
          width: "100%",
        }}
      >
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={() => toggleDrawer({})}
        >
          <AddIcon />
          Add item
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: 2,
          width: "100%",
        }}
      >
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={(e) => setFile(e.target.files?.[0] || undefined)}
        />
        {file && (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => handleFileUpload()}
          >
            Upload
          </Button>
        )}
      </Box>
      <CollapsibleTable
        header={[
          "Name",
          "Description",
          "Amount",
          "Cost per item",
          "Price",
          "",
          "",
        ]}
        rows={material.map((material) => {
          return {
            cells: [
              material.name,
              material.description,
              material.amountOfItems,
              material.costPerItem,
              material.pricePerItem,
              <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={() => openEdit(material)}
              >
                Edit
              </Button>,
              <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={() => deleteItem(material.id)}
              >
                Delete
              </Button>,
            ],
          };
        })}
      />
      <Drawer anchor={"right"} open={openDrawer} onClose={toggleDrawer}>
        <div className="p-[24px] pt-[88px]">
          {isEdit ? "Edit" : "Add"} Material
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-[24px]"
          >
            <TextField
              id="outlined-basic"
              label="Name"
              variant="outlined"
              {...register("name", { required: true })}
            />
            <TextField
              id="outlined-basic"
              label="Amount"
              variant="outlined"
              {...register("amountOfItems", { required: true })}
            />
            <TextField
              id="outlined-basic"
              label="Cost"
              variant="outlined"
              {...register("costPerItem", { required: true })}
            />
            <TextField
              id="outlined-basic"
              label="Price"
              variant="outlined"
              {...register("pricePerItem", { required: true })}
            />
            <Button type="submit" variant="contained" color="secondary">
              Save
            </Button>
          </form>
        </div>
      </Drawer>
    </Box>
  );
};

export default MaterialList;
